/**
 * Common error codes
 */
export var ErrorCode;
(function (ErrorCode) {
    // Authentication
    ErrorCode["UNAUTHORIZED"] = "UNAUTHORIZED";
    ErrorCode["FORBIDDEN"] = "FORBIDDEN";
    ErrorCode["TOKEN_EXPIRED"] = "TOKEN_EXPIRED";
    // Hunt errors
    ErrorCode["HUNT_NOT_FOUND"] = "HUNT_NOT_FOUND";
    ErrorCode["INVALID_JOIN_CODE"] = "INVALID_JOIN_CODE";
    ErrorCode["HUNT_ALREADY_STARTED"] = "HUNT_ALREADY_STARTED";
    ErrorCode["HUNT_NOT_ACTIVE"] = "HUNT_NOT_ACTIVE";
    ErrorCode["MAX_PARTICIPANTS_REACHED"] = "MAX_PARTICIPANTS_REACHED";
    // Pin errors
    ErrorCode["PIN_NOT_FOUND"] = "PIN_NOT_FOUND";
    ErrorCode["INVALID_GPS_ACCURACY"] = "INVALID_GPS_ACCURACY";
    ErrorCode["PIN_LIMIT_REACHED"] = "PIN_LIMIT_REACHED";
    // Participant errors
    ErrorCode["ALREADY_JOINED"] = "ALREADY_JOINED";
    ErrorCode["NOT_A_PARTICIPANT"] = "NOT_A_PARTICIPANT";
    ErrorCode["INVALID_ROLE"] = "INVALID_ROLE";
    // General errors
    ErrorCode["VALIDATION_ERROR"] = "VALIDATION_ERROR";
    ErrorCode["INTERNAL_ERROR"] = "INTERNAL_ERROR";
    ErrorCode["RATE_LIMITED"] = "RATE_LIMITED";
})(ErrorCode || (ErrorCode = {}));
/**
 * Create a success response
 */
export function successResponse(data) {
    return {
        success: true,
        data,
        timestamp: new Date().toISOString(),
    };
}
/**
 * Create an error response
 */
export function errorResponse(code, message, details) {
    return {
        success: false,
        error: { code, message, details },
        timestamp: new Date().toISOString(),
    };
}
//# sourceMappingURL=api.js.map